'use client';

import { markdownTrilogy } from '@bytel/markdown-trilogy';
import {
    Align,
    Button,
    ButtonList,
    ButtonVariant,
    DirectionEnum,
    FlexBox,
    GapSize,
    Icon,
    IconName,
    IconSize,
    Image,
    Modal,
    ModalBody,
    ModalFooter,
    Row,
    Rows,
    Spacer,
    SpacerSize,
    Text,
    TextLevels,
    Title,
    TitleLevels,
    TypographyAlign,
} from '@bytel/trilogy-react';

import { ContentEditorImageType } from '@app-types/cms';

import { Cms } from '@components/cms';
import { SSIBlock } from '@components/ssi-block';

type BundlePopinItem = {
    icon_trilogy: string;
    title: string;
    text: string;
};

interface RoamingModalProps {
    active: boolean;
    onClose: () => void;
    title: string;
    roamingDestinations?: string;
    bundlePopin?: BundlePopinItem[];
    bundleImage?: ContentEditorImageType;
    bundleDescriptionOffer?: string;
}

export function RoamingModal({
    active,
    onClose,
    title,
    roamingDestinations,
    bundlePopin,
    bundleImage,
    bundleDescriptionOffer,
}: Readonly<RoamingModalProps>) {
    return (
        <Modal active={active} onClose={onClose} title={title}>
            <ModalBody>
                {bundleImage && (
                    <>
                        <FlexBox align={Align.CENTER} direction={DirectionEnum.COLUMN}>
                            <Image src={bundleImage.public_url} alt='' className='product-detail-special-image' />
                            <Title typo={TypographyAlign.TEXT_CENTERED} level={TitleLevels.SIX} marginless>
                                {bundleDescriptionOffer}
                            </Title>
                            <Spacer size={SpacerSize.ONE} />
                        </FlexBox>
                        <Spacer size={SpacerSize.FOUR} />
                    </>
                )}
                {bundlePopin && bundlePopin.length > 0 && (
                    <>
                        <Rows gap={4}>
                            {bundlePopin.map((item) => (
                                <Row key={item.icon_trilogy + item.title}>
                                    <FlexBox direction={DirectionEnum.COLUMN} gap={GapSize.ZERO}>
                                        <FlexBox align={Align.CENTER}>
                                            <Icon name={item.icon_trilogy as IconName} size={IconSize.SMALL} />
                                            <Text level={TextLevels.TWO} marginless>
                                                <strong>{item.title}</strong>
                                            </Text>
                                        </FlexBox>
                                        <Text level={TextLevels.TWO} marginless typo={TypographyAlign.TEXT_LEFT}>
                                            {item.text}
                                        </Text>
                                    </FlexBox>
                                </Row>
                            ))}
                        </Rows>
                        <Spacer size={SpacerSize.EIGHT} />
                        <Title level={TitleLevels.THREE}>Destinations incluses dans ce forfait</Title>
                    </>
                )}
                {roamingDestinations ? (
                    <Cms content={markdownTrilogy(roamingDestinations)} />
                ) : (
                    <SSIBlock url='/partials/mobiles/banniere_forfaits-mobiles_destinations_europe' />
                )}
            </ModalBody>
            <ModalFooter>
                <ButtonList>
                    <Button onClick={onClose} variant={ButtonVariant.PRIMARY}>
                        Fermer
                    </Button>
                </ButtonList>
            </ModalFooter>
        </Modal>
    );
}
